
import { defineComponent, PropType } from 'vue'
import InputError from '@/components/ui/InputError.vue'
import { checkErrorsReturn } from '@/use/validInput'
import { theme } from '@/config/styles'

const __default__ = defineComponent({
    components: {
        InputError,
    },
    props: {
        isInvalid: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array as PropType<string[]> | undefined,
            default: () => {
                return ['']
            },
        },
        modelValue: {
            type: Boolean,
            required: true,
        },
        labelMessage: {
            type: String,
            default: '',
        },
        nameID: {
            type: String,
            required: true,
        },
    },
    inheritAttrs: false,
    setup() {
        return {
            checkErrorsReturn,
            theme
        }
    },
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "b5a7d4c6": (_ctx.theme.colors.primary.midlight),
  "efa88eb4": (_ctx.theme.colors.white)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__